import React from 'react'
import { withStyles, WithStyles, CircularProgress } from '@zn-material-ui'

import loadingStyles from './LoadingStyle'

type IProps = WithStyles<typeof loadingStyles>

const Loading = (props: IProps) => {
  const { classes } = props
  return (
    <div className={classes.loading}>
      <CircularProgress className={classes.progress} />
    </div>
  )
}

export default withStyles(loadingStyles)(Loading)
